import fakeDataProvider from 'ra-data-fakerest';
import buildGraphQLProvider from 'ra-data-graphql';
import React from 'react';
import {
  Admin,
  ChipField,
  Edit,
  ImageField,
  required,
  Resource,
  SimpleForm,
} from 'react-admin';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import AdminLogin from 'routes/admin/admin-login';
import AdminSignInCodeForm from 'routes/admin/admin-sign-in-code-form';
import AdminSignInCodeList from 'routes/admin/admin-sign-in-code-list';
import { AdminLayout } from 'routes/admin/style';
import ForgotPassword from 'routes/auth/forgot-password';
import Login from 'routes/auth/login';
import LoginNikKeys from 'routes/auth/loginNikKeys';
import Register from 'routes/auth/register';
import RegisterNikKeys from 'routes/auth/registerNikKeys';
import PrivateRoute from 'routes/components/private-route';
import Home from 'routes/home';
import NotFound from 'routes/not-found';
import Surface from 'routes/surface';
import AdminBackgroundList from './admin/admin-backgrounds';
import AdminBackgroundForm from './admin/admin-backgrounds-form';
import SharePage from './share/share-page';
import TemplatePage from './share/template-page';

import { defaultTheme } from 'react-admin';
import { color } from '../styles/settings';

import apolloClient from 'services/apollo-client';
import { ThemeProvider } from 'styled-components';

// import { defaultTheme } from "react-admin";
import { createMuiTheme } from '@material-ui/core/styles';

// import { color, typography } from 'styles/settings';

import {
  ArrayField,
  BooleanField,
  Datagrid,
  List,
  Show,
  SimpleShowLayout,
  TextField,
} from 'react-admin';

import gql from 'graphql-tag';
import { backgroundTemplatesQuery } from 'graphql/admin/backgrounds';
import { signInCodesQuery } from 'graphql/admin/sign-in-codes';
import { fetchUsersQuery } from 'graphql/admin/users';
import HomeNik from './homeNik';
import ListNik from './list';
import DetailNik from './listDetail';
import DetailEntry from './listDetailEntry';
import TemplateNik from './template';
import { templateList } from './templates/tempates';
import { themeCX } from 'App';
import TextInput from 'components/text-input';
// import buildGraphQLProvider from 'ra-data-graphql-simple';

const themeImmo = {
  ...color.themeIM,
  name: 'immoox',
  logo: '',
};

export const templates = templateList;

const _fakeDataProvider = fakeDataProvider({
  posts: [
    { id: 0, title: 'Hello, world!' },
    { id: 1, title: 'FooBar' },
  ],
  Users: [
    {
      id: 0,
      name: 'Max Ochsenhofer',
      email: 'm.ochsenhofer@cortelx.at',
      risEnabled: true,
      locked: false,
      scope: 'CORTLEX',
    },
    {
      id: 1,
      name: 'Bernd Bergler',
      email: 'bernd.bergler@gmail.com',
      risEnabled: false,
      locked: false,
      scope: 'NIKKEYS',
    },
  ],
  backgrounds: [
    { id: 0, title: 'Hello, world!' },
    { id: 1, title: 'FooBar' },
  ],

  'sign-in-codes': [
    { id: 0, code: 'bbb', usedByUser: 0 },
    { id: 1, code: 'aaa' },
  ],
  comments: [
    { id: 0, post_id: 0, author: 'John Doe', body: 'Sensational!' },
    { id: 1, post_id: 0, author: 'Jane Doe', body: 'I agree' },
  ],
  Templates: templates,
});

const User2Show = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="id" />
      {/* <TextField source="description" /> */}
      {/* <ArrayField source="tags">
        <SingleFieldList>
          <ChipField source="name" size="small" />
        </SingleFieldList>
      </ArrayField> */}
      {/* <ArrayField source="entries">
        <Datagrid bulkActionButtons={false}>
          <TextField source="type" />
          <TextField source="text" />
          <BooleanField source="required" />
        </Datagrid>
      </ArrayField> */}
    </SimpleShowLayout>
  </Show>
);

const PostShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="title" />
      {/* <TextField source="description" /> */}
      {/* <ArrayField source="tags">
        <SingleFieldList>
          <ChipField source="name" size="small" />
        </SingleFieldList>
      </ArrayField> */}
      <ArrayField source="entries">
        <Datagrid bulkActionButtons={false}>
          <TextField source="type" />
          <TextField source="text" />
          <BooleanField source="required" />
        </Datagrid>
      </ArrayField>
    </SimpleShowLayout>
  </Show>
);

export const PostList = () => (
  <List basePath="/admin-new">
    <Datagrid>
      <TextField source="id" />
      <TextField source="title" />
      {/* <DateField source="published_at" />
          <TextField source="average_note" />
          <TextField source="views" />
          <EditButton /> */}
    </Datagrid>
  </List>
);

export const UserList = (props) => (
  <List {...props}>
    <Datagrid rowClick="show">
      <TextField source="id" />
      <TextField source="fullName" />
      <TextField source="email" />
      <TextField source="createdAt" />
      <TextField source="lastLogin" />
      <ChipField source="attributes" />
      {/* <TextField source="scope" />
      <BooleanField source="risEnabled" />
      <BooleanField source="locked" /> */}
      {/* <DateField source="published_at" />
          <TextField source="average_note" />
          <TextField source="views" />
          <EditButton /> */}
    </Datagrid>
  </List>
);

const UserShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="fullName" />
      <TextField source="email" />
      <TextField source="createdAt" />
      <TextField source="lastLogin" />
      {/* <TextField source="description" /> */}
      {/* <ArrayField source="tags">
        <SingleFieldList>
          <ChipField source="name" size="small" />
        </SingleFieldList>
      </ArrayField> */}
      {/* <ArrayField source="entries">
        <Datagrid bulkActionButtons={false}>
          <TextField source="type" />
          <TextField source="text" />
          <BooleanField source="required" />
        </Datagrid>
      </ArrayField> */}
    </SimpleShowLayout>
  </Show>
);

export const UserEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput disabled label="Id" source="id" />
      <TextInput label="name" source="fullName" validate={required()} />
      <TextInput source="email" validate={required()} />
      {/* <TextInput multiline source="teaser" validate={required()} />
          <RichTextInput source="body" validate={required()} />
          <DateInput label="Publication date" source="published_at" />
          <ReferenceManyField label="Comments" reference="comments" target="post_id">
              <Datagrid>
                  <TextField source="body" />
                  <DateField source="created_at" />
                  <EditButton />
              </Datagrid>
          </ReferenceManyField> */}
    </SimpleForm>
  </Edit>
);

export const StatList = (props) => (
  <List {...props}>
    <Datagrid>
      {/* <TextField source="id" /> */}
      <TextField source="title" />
      <TextField source="value" label={'MQ erstellt'} />
      <TextField source="name" label={'Anfragen erhalten'} />
      {/* <TextField source="scope" />
      <BooleanField source="risEnabled" />
      <BooleanField source="locked" /> */}
      {/* <DateField source="published_at" />
          <TextField source="average_note" />
          <TextField source="views" />
          <EditButton /> */}
    </Datagrid>
  </List>
);

export const BackgroundList = (props) => (
  <List {...props}>
    <Datagrid>
      <TextField source="id" />
      <TextField source="title" />
      <TextField source="description" />
      <ImageField source="url" />

      {/* <DateField source="published_at" />
          <TextField source="average_note" />
          <TextField source="views" />
          <EditButton /> */}
    </Datagrid>
  </List>
);

export const TemplateList = (props) => (
  <List {...props}>
    <Datagrid rowClick="show">
      <TextField source="id" />
      <TextField source="title" />
      <TextField source="description" />
      {/* <ImageField source="url" /> */}

      {/* <DateField source="published_at" />
          <TextField source="average_note" />
          <TextField source="views" />
          <EditButton /> */}
    </Datagrid>
  </List>
);

export const CodesList = () => (
  <List basePath="/admin-new">
    <Datagrid>
      <TextField source="id" />
      <TextField source="code" />
      <TextField source="usedOn" />
      <TextField source="email" />
      {/* <FunctionField
    label="Name"
    render={record => `${record.first_name} ${record.last_name}`}
/>;
              label={t('Sign in URL')}
              name="code"
              onClick={(event, code) => {
                window.open(
                  window.location.origin + '/register?code=' + code,
                  '_blank',
                );
              }}>
              {({ data }) => {
                return window.location.origin + '/register?code=' + data.code;
              }}
            </Table.Field>
            <Table.Action
              label=" "
              icon={<CopyIcon />}
              onClick={(data) => {
                try {
                  copyToClipboard(
                    window.location.origin + '/register?code=' + data.code,
                  );
                  toast.success(t('Successfully copied to clipboard'));
                } catch (error) {
                  toast.success(t('Something went wrong'));
                }
              }}
            /> */}

      {/* <DateField source="published_at" />
          <TextField source="average_note" />
          <TextField source="views" />
          <EditButton /> */}
    </Datagrid>
  </List>
);

const theme = createMuiTheme({
  ...defaultTheme,
  palette: {
    // primary:
    // {
    //   500: color.brand.gold,
    // },

    // secondary: {
    //   500: "#ff00ff"
    // } ,
    // error: red,
    contrastThreshold: 3,
    tonalOffset: 0.2,
  },
  sidebar: {
    width: 300, // The default value is 240
    closedWidth: 70, // The default value is 55
  },
});

var today = new Date();

var date30 = new Date();
date30.setDate(date30.getDate() - 30);
var dateString30 = date30.toISOString().split('T')[0]; //

var date60 = new Date();
date60.setDate(date60.getDate() - 60);
var dateString60 = date60.toISOString().split('T')[0]; //

const q = `
query {
  last30_2: stats(input: { start: "${dateString60}", end: "${dateString30}" }) {
    name
    value
  }

  last30: stats(input: { start: "${dateString30}", end: "${
  today.toISOString().split('T')[0]
}" }) {
    name
    value
  }

  overall: stats {
    name
    value
  }
}
`;

const statsQuery = gql(q);

const queries = {
  SignInCode: signInCodesQuery,
  Background: backgroundTemplatesQuery,
  User: fetchUsersQuery,
  Stats: statsQuery,
  // Templates: templatesQuery,
};

const buildQuery = (introspectionResults) => (
  raFetchType,
  resourceName,
  params,
) => {
  const resource = introspectionResults.resources.find(
    (r) => r.type.name === resourceName,
  );
  console.log(
    'buildQuery  ',
    raFetchType,
    resourceName,
    params,
    introspectionResults,
    resource,
  );
  const string1 =
    resourceName.charAt(0).toLowerCase() + resourceName.slice(1) + 's';
  console.log(`FETCH ${resourceName} ${string1}`);
  switch (raFetchType) {
    case 'GET_LIST':
      // if(resourceName=="templates"){
      //   return
      // }
      return {
        query: queries[resourceName],
        variables: {
          input: { offset: params.pagination, sort: params.sort.field },
        }, // params = { id: ... }
        parseResponse: (response) => {
          console.log('APRSE ', response, resourceName);
          if (resourceName === 'Stats') {
            return {
              data: [
                { id: 1, title: 'overall', ...response.data.overall },
                { id: 2, title: 'last 30 days', ...response.data.last30 },
                { id: 3, title: '30 days before', ...response.data.last30_2 },
              ],
              total: 1,
            };
          } else {
            const d = response.data[string1];
            return { data: d.nodes, total: d.meta.totalCount };
          }
        },
      };
    case 'GET_ONE':
      console.log('PARAMS ', params, resourceName);
      return {
        query: queries[resourceName],
        variables: {
          input: {
            // offset: params.pagination,
            // sort: params.sort.field,
            filter: {
              id: params.id,
            },
          },
        }, // params = { id: ... }
        parseResponse: (response) => {
          console.log('APRSE GET ONE ', response, resourceName);
          if (resourceName === 'Stats') {
            return {
              data: [
                { id: 1, title: 'overall', ...response.data.overall },
                { id: 2, title: 'last 30 days', ...response.data.last30 },
                { id: 3, title: '30 days before', ...response.data.last30_2 },
              ],
              total: 1,
            };
          } else {
            const d = response.data[string1];
            console.log('GET ONE DATA ', d);
            return { data: d.nodes[0] };
          }
        },
      };
    default:
      throw 'ASSDSDDA';
    // break;
    // ... other types handled here
  }
};

const mockBuildQueryFactory = (introspectionResults) => {
  return (raFetchType, resourceName, params) => {
    const resource = introspectionResults.resources.find(
      (r) => r.type.name === resourceName,
    );
    console.log(
      'buildQuery  ',
      raFetchType,
      resourceName,
      params,
      introspectionResults,
      resource,
    );
    return {
      query: signInCodesQuery,
      variables: params, // params = { id: ... }
      parseResponse: (response) => {
        console.log('APRSE ', response);
        return response;
      },
    };
  };
};

class CompositeDataProvider {
  constructor(dataProviders) {
    this.dataProviders = dataProviders;
  }

  _delegate(name, resource, params) {
    const { dataProvider } = this.dataProviders.find((dp) =>
      dp.resources.includes(resource),
    );

    return dataProvider[name](resource, params);
  }

  getList(resource, params) {
    return this._delegate('getList', resource, params);
  }
  getOne(resource, params) {
    return this._delegate('getOne', resource, params);
  }
  getMany(resource, params) {
    return this._delegate('getMany', resource, params);
  }
  getManyReference(resource, params) {
    return this._delegate('getManyReference', resource, params);
  }
  create(resource, params) {
    return this._delegate('create', resource, params);
  }
  update(resource, params) {
    return this._delegate('update', resource, params);
  }
  updateMany(resource, params) {
    return this._delegate('updateMany', resource, params);
  }
  delete(resource, params) {
    return this._delegate('delete', resource, params);
  }
  deleteMany(resource, params) {
    return this._delegate('deleteMany', resource, params);
  }
}

export const StoreAdmin = () => {
  const [dataProvider2, setDataProvider] = React.useState(null);
  React.useEffect(() => {
    buildGraphQLProvider({ client: apolloClient, buildQuery: buildQuery })
      // buildGraphQLProvider({ clientOptions: {

      //   uri: process.env.REACT_APP_GRAPHQL_URL,
      //   credentials: "Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6IjJwUXFEYV94cG1zMXFjM29tWGJTciJ9.eyJodHRwczovL215LmNvcnRsZXguYXQvZW1haWwiOiJiZXJuZEA5eS5jbyIsImh0dHBzOi8vbXkuY29ydGxleC5hdC9pZCI6IjYwNzg5MjhjZTNjZTRmMWI4MDJjYjk1OGY2YWZkZTFmIiwiaXNzIjoiaHR0cHM6Ly9jb3J0bGV4LXByb2QuZXUuYXV0aDAuY29tLyIsInN1YiI6ImF1dGgwfDVlY2ZkOTUwZTVkOGY2MGMxOGEzY2NjOCIsImF1ZCI6WyJ3ZWJhcHAiLCJodHRwczovL2NvcnRsZXgtcHJvZC5ldS5hdXRoMC5jb20vdXNlcmluZm8iXSwiaWF0IjoxNjc5OTk1ODk5LCJleHAiOjE2ODAwODIyOTksImF6cCI6InRoME45QmRPR2xsRDJjckJHcWR4NzMyVm9IUk1GUjhzIiwic2NvcGUiOiJvcGVuaWQgcHJvZmlsZSBlbWFpbCIsImd0eSI6InBhc3N3b3JkIn0.aVotyi2u7P9aEThml7B3tMvDclFQ21fced5LaLuwc-SAMOZCGRLiVCZkO5ZjrRlepd3QBCvkermsEmB3xeoRfwpYxAOHTkh9nCYOmhVGmHps1a4NNfGxNy3-_FNoIzPRNpGlWNHKUjPMfWgrHRSXBjX2YZZ2YG6Yes-Ui0kFhPvoK1hK3nJ9ihtRHyfFlHAoHSl05t06y6tRh9_0CtZ9PsJeV0XRtKgg0OGVCRTXYiRIZkavyhkq0l3EHnN_tQqNFcrd3wV49JoY88RVBk7aZdgVxp9LRavhlT5XpAvToFXc9a-_SW6AKXeZVuTYO-piSyQ9SJ0aUo1ooAylOAoVnA",
      //   headers: {
      //     Test: "no",
      //     Authorization: "Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6IjJwUXFEYV94cG1zMXFjM29tWGJTciJ9.eyJodHRwczovL215LmNvcnRsZXguYXQvZW1haWwiOiJiZXJuZEA5eS5jbyIsImh0dHBzOi8vbXkuY29ydGxleC5hdC9pZCI6IjYwNzg5MjhjZTNjZTRmMWI4MDJjYjk1OGY2YWZkZTFmIiwiaXNzIjoiaHR0cHM6Ly9jb3J0bGV4LXByb2QuZXUuYXV0aDAuY29tLyIsInN1YiI6ImF1dGgwfDVlY2ZkOTUwZTVkOGY2MGMxOGEzY2NjOCIsImF1ZCI6WyJ3ZWJhcHAiLCJodHRwczovL2NvcnRsZXgtcHJvZC5ldS5hdXRoMC5jb20vdXNlcmluZm8iXSwiaWF0IjoxNjc5OTk1ODk5LCJleHAiOjE2ODAwODIyOTksImF6cCI6InRoME45QmRPR2xsRDJjckJHcWR4NzMyVm9IUk1GUjhzIiwic2NvcGUiOiJvcGVuaWQgcHJvZmlsZSBlbWFpbCIsImd0eSI6InBhc3N3b3JkIn0.aVotyi2u7P9aEThml7B3tMvDclFQ21fced5LaLuwc-SAMOZCGRLiVCZkO5ZjrRlepd3QBCvkermsEmB3xeoRfwpYxAOHTkh9nCYOmhVGmHps1a4NNfGxNy3-_FNoIzPRNpGlWNHKUjPMfWgrHRSXBjX2YZZ2YG6Yes-Ui0kFhPvoK1hK3nJ9ihtRHyfFlHAoHSl05t06y6tRh9_0CtZ9PsJeV0XRtKgg0OGVCRTXYiRIZkavyhkq0l3EHnN_tQqNFcrd3wV49JoY88RVBk7aZdgVxp9LRavhlT5XpAvToFXc9a-_SW6AKXeZVuTYO-piSyQ9SJ0aUo1ooAylOAoVnA"
      //   },
      // }})
      .then((graphQlDataProvider) => {
        const dataProvider = new CompositeDataProvider([
          {
            dataProvider: graphQlDataProvider,
            resources: ['SignInCode', 'Background', 'User', 'Stats'],
          },
          {
            dataProvider: _fakeDataProvider,
            resources: ['Templates'],
          },
        ]);
        setDataProvider(dataProvider);
      });
  }, []);

  if (!dataProvider2) {
    return <div>Loading </div>;
  }

  return (
    <Admin dataProvider={dataProvider2} title="CORTLEX ADMIN">
      {/* <Resource name="posts" {...posts} /> */}
      {/* <Resource name="posts" list={PostList} /> */}
      {/* <Resource name="users" list={UserList} />
        <Resource name="backgrounds" list={BackgroundList} />
        <Resource name="sign-in-codes" list={BackgroundList} /> */}
      <Resource name="User" list={UserList} show={UserShow} edit={UserEdit} />
      <Resource name="SignInCode" list={CodesList} />
      <Resource name="Background" list={BackgroundList} />
      <Resource name="Templates" list={TemplateList} show={PostShow} />
      <Resource name="Stats" list={StatList} />
    </Admin>
  );
};

// const myTheme = merge({}, defaultTheme, {
//     palette: {
//         primary: indigo,
//         secondary: pink,
//         error: red,
//         contrastThreshold: 3,
//         tonalOffset: 0.2,
//     },
//     typography: {
//         // Use the system font instead of the default Roboto font.
//         fontFamily: ['-apple-system', 'BlinkMacSystemFont', '"Segoe UI"', 'Arial', 'sans-serif'].join(','),
//     },
//     overrides: {
//         MuiButton: { // override the styles of all instances of this component
//             root: { // Name of the rule
//                 color: 'white', // Some CSS
//             },
//         },
//     },
// });

function Routes() {
  return (
    <BrowserRouter>
      <Switch>
        <Route
          path="/admin"
          render={({ match: { url } }) => (
            <>
              <Route path={`${url}/login`} component={AdminLogin} exact />
              <AdminLayout>
                <Route
                  path={`${url}/sign-in-code/form`}
                  component={AdminSignInCodeForm}
                />
                <Route
                  path={`${url}/sign-in-code/list`}
                  component={AdminSignInCodeList}
                />
                <Route
                  path={`${url}/background/list`}
                  component={AdminBackgroundList}
                />
                <Route
                  path={`${url}/background/form`}
                  component={AdminBackgroundForm}
                />
              </AdminLayout>
            </>
          )}
        />

        <Route
          path="/admin-new"
          render={({ match: { url } }) => (
            <>
              <Route path={`${url}/*`} render={() => <StoreAdmin />} />
              <Route
                path={`${url}`}
                render={(routeProps) => (
                  <StoreAdmin basePath={routeProps.match.url} />
                )}
              />
            </>
          )}
        />

        <Route
          path="/share"
          render={({ match: { url } }) => (
            <>
              <Route
                path={`${url}/incomming/:key`}
                component={SharePage}
                exact
              />
              <ThemeProvider theme={themeImmo}>
                <Route
                  path={`${url}/template/:surface`}
                  component={TemplatePage}
                  exact
                />
              </ThemeProvider>

              <ThemeProvider theme={themeCX}>
                <Route
                  path={`${url}/cortlex/:surface`}
                  component={TemplatePage}
                  exact
                />
              </ThemeProvider>
              {/*               <AdminLayout>
                <Route
                  path={`${url}/sign-in-code/form`}
                  component={AdminSignInCodeForm}
                />
                <Route
                  path={`${url}/sign-in-code/list`}
                  component={AdminSignInCodeList}
                />
              </AdminLayout> */}
            </>
          )}
        />

        <Route path="/login">
          <Login />
        </Route>
        {/* <Route path="/login-nickkeys">
          <Login />
        </Route> */}

        {/* <Route path="/immo-ox/login">
          <Login />
        </Route> */}
        <Route path="/register">
          <Register />
        </Route>
        <Route path="/forgot-password">
          <ForgotPassword />
        </Route>

        <Route path="/test">{'TEST'}</Route>
        <PrivateRoute path="/surface/:id">
          <Surface />
        </PrivateRoute>
        <Route path="/not-found">
          <NotFound />
        </Route>
        <Route path="/" exact={true}>
          <Home path="/surface/" />
        </Route>
        <Route path="/immoox*">
          <Home path="/immo-ox/list/" />
        </Route>
        <ThemeProvider theme={themeImmo}>
          <Route
            path="/immo-ox"
            render={({ match: { url } }) => (
              <>
                <Route path={`${url}`} exact={true}>
                  {/* <LoginNikKeys /> */}
                  <Home path="/immo-ox/list/" />
                </Route>

                <Route path={`${url}/login`}>
                  <LoginNikKeys />
                </Route>
                <Route path={`${url}/register`}>
                  <RegisterNikKeys />
                </Route>

                <Route path={`${url}/list`}>
                  <HomeNik />
                </Route>
                <Route path={`${url}/list/:id`} exact={true}>
                  <ListNik />
                </Route>
                <Route path={`${url}/detail/:id/:entry`} exact={true}>
                  <DetailEntry />
                </Route>

                <Route path={`${url}/detail/:id`} exact={true}>
                  <DetailNik />
                </Route>

                <Route path={`${url}/template/:id`}>
                  <TemplateNik />
                </Route>
              </>
            )}
          />
        </ThemeProvider>

        <Route path="*">
          <NotFound />
        </Route>
      </Switch>
    </BrowserRouter>
  );
}

export default Routes;
